import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class ReleasesCount extends Field {
  static attributesForModel() {
    return ['releasesCount'];
  }

  get title() {
    return `${terminology('Releases')} count`;
  }

  exampleContents(): FieldContentsData {
    return { text: `3 ${terminology('releases')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      text: `${record.releasesCount} ${terminology('releases', {
        isPlural: record.releasesCount > 1,
      })}`,
    };
  }
}
